module.exports = {
          srcSet: __webpack_public_path__ + "2fd3ba05cd21b92388e994604e01ce23-1168.png"+" 1168w",
          images:[ {path: __webpack_public_path__ + "2fd3ba05cd21b92388e994604e01ce23-1168.png",width: 1168,height: 198}],
          src: __webpack_public_path__ + "2fd3ba05cd21b92388e994604e01ce23-1168.png",
          toString:function(){return __webpack_public_path__ + "2fd3ba05cd21b92388e994604e01ce23-1168.png"},
          placeholder: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAACCAIAAADuA9qHAAAACXBIWXMAAAsTAAALEwEAmpwYAAAASUlEQVR4nAE+AMH/AOR5/dF/5rJ6z66C0L2L59N7v9J2m+Wgt9mbfPWZOQDFKfG4MOicS82VXsKiZNOvXqC7ZaTPfdjFdYLriaDgGSb0kJ6ZsQAAAABJRU5ErkJggg==",
          width: 1168,
          height: 198
        }